"use client";

/**
 * NewForm DS animated icon — a spreadsheet grid. The frame draws on, then
 * the inner grid lines draw in row-by-row / column-by-column. Brand purple
 * by default. See ./shared for the animation/colour conventions.
 */

import { motion } from "motion/react";
import {
  type AnimatedIconProps,
  drawProps,
  IconSvg,
  useReduce,
} from "./shared";

export function SpreadsheetIcon({ size, className }: AnimatedIconProps) {
  const reduce = useReduce();
  return (
    <IconSvg size={size} className={className}>
      <motion.rect
        x="3"
        y="3"
        width="18"
        height="18"
        rx="2"
        {...drawProps(reduce, 0)}
      />
      <motion.path d="M3 9h18" {...drawProps(reduce, 0.22)} />
      <motion.path d="M3 15h18" {...drawProps(reduce, 0.36)} />
      <motion.path d="M9 3v18" {...drawProps(reduce, 0.5)} />
      <motion.path d="M15 3v18" {...drawProps(reduce, 0.64)} />
    </IconSvg>
  );
}
